import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "column",
  "data-test": "queued-commands-list"
}
const _hoisted_2 = { class: "row items-center no-wrap q-mb-xs" }
const _hoisted_3 = {
  key: 0,
  class: "text-negative text-caption q-mb-xs"
}
const _hoisted_4 = {
  key: 1,
  class: "text-grey-7 text-caption"
}
const _hoisted_5 = {
  key: 0,
  class: "text-grey-7 text-caption q-mb-xs",
  "data-test": "queued-commands-uid-filter-count"
}
const _hoisted_6 = {
  key: 1,
  class: "row items-center no-wrap text-grey-7 text-caption q-mb-xs",
  "data-test": "queued-commands-uid-filter-empty"
}
const _hoisted_7 = { class: "text-weight-medium" }
const _hoisted_8 = { class: "q-ml-xs" }
const _hoisted_9 = { class: "row no-wrap items-center" }
const _hoisted_10 = {
  key: 0,
  class: "inline-block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_EditQueuedRangeDialog = _resolveComponent("EditQueuedRangeDialog")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-bold col" }, "Queued Download Commands", -1)),
      _createVNode(_component_q_btn, {
        flat: "",
        dense: "",
        round: "",
        size: "sm",
        icon: "refresh",
        loading: _ctx.isLoading,
        "data-test": "queued-commands-refresh",
        onClick: _ctx.fetchQueuedCommands
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tooltip, null, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Refresh", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
      : (!_ctx.isLoading && _ctx.commands.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " There are no queued download commands. "))
        : _createCommentVNode("", true),
    (_ctx.commands.length > 0 || _ctx.uidFilterText)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createVNode(_component_q_input, {
            modelValue: _ctx.uidFilterText,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.uidFilterText) = $event)),
            dense: "",
            outlined: "",
            clearable: "",
            autogrow: "",
            type: "textarea",
            color: "blue-brand",
            label: "AGM UIDs",
            hint: "One or more, separated by commas, spaces or new lines",
            class: "q-mb-sm",
            "data-test": "queued-commands-uid-filter",
            onClear: _ctx.clearUidFilter
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_q_icon, { name: "search" })
            ]),
            _: 1
          }, 8, ["modelValue", "onClear"]),
          (_ctx.isUidFilterActive && _ctx.filteredCommands.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Showing " + _toDisplayString(_ctx.filteredCommands.length) + " of " + _toDisplayString(_ctx.commands.length), 1))
            : _createCommentVNode("", true),
          (
          _ctx.isUidFilterActive &&
          _ctx.commands.length > 0 &&
          _ctx.filteredCommands.length === 0
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "col" }, "No queued commands match these AGM UIDs.", -1)),
                _createVNode(_component_q_btn, {
                  flat: "",
                  dense: "",
                  "no-caps": "",
                  size: "sm",
                  color: "blue-brand",
                  label: "Clear filter",
                  onClick: _ctx.clearUidFilter
                }, null, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.filteredCommands.length > 0)
      ? (_openBlock(), _createBlock(_component_q_list, {
          key: 3,
          dense: "",
          bordered: "",
          separator: "",
          class: "rounded-borders",
          style: {"max-height":"320px","overflow-y":"auto"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCommands, (command) => {
              return (_openBlock(), _createBlock(_component_q_item, {
                key: command.commandId,
                "data-test": 'queued-command-' + command.commandId
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_7, "UID " + _toDisplayString(command.uid), 1),
                          _createTextVNode(" · " + _toDisplayString(_ctx.typeLabel(command)) + " ", 1),
                          (command.transport === 'Iridium')
                            ? (_openBlock(), _createBlock(_component_q_badge, {
                                key: 0,
                                outline: "",
                                color: "grey-7",
                                label: "Iridium",
                                class: "q-ml-xs"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024),
                      (_ctx.rangeText(command))
                        ? (_openBlock(), _createBlock(_component_q_item_label, {
                            key: 0,
                            caption: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.rangeText(command)) + " UTC ", 1)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true),
                      (_ctx.isAdmin && command.isDownload && !_ctx.canEdit(command))
                        ? (_openBlock(), _createBlock(_component_q_item_label, {
                            key: 1,
                            caption: "",
                            class: "text-grey-7",
                            "data-test": 'queued-command-edit-reason-' + command.commandId
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.editReason(command)), 1)
                            ]),
                            _: 2
                          }, 1032, ["data-test"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_q_item_label, { caption: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_badge, {
                            color: _ctx.statusColor(command),
                            label: _ctx.statusLabel(command)
                          }, null, 8, ["color", "label"]),
                          _createElementVNode("span", _hoisted_8, "queued " + _toDisplayString(_ctx.queuedAt(command)) + " UTC", 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_q_item_section, { side: "" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        (command.downloadSessionId && _ctx.canShowSessions)
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 0,
                              flat: "",
                              dense: "",
                              round: "",
                              size: "sm",
                              icon: "visibility",
                              onClick: ($event: any) => (_ctx.onShowSessionClick(command))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_tooltip, null, {
                                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                    _createTextVNode("Show download session", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (_ctx.isAdmin)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (command.isDownload)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      dense: "",
                                      round: "",
                                      size: "sm",
                                      icon: "edit",
                                      disable: !_ctx.canEdit(command),
                                      "data-test": 'queued-command-edit-' + command.commandId,
                                      onClick: ($event: any) => (_ctx.onEditClick(command))
                                    }, null, 8, ["disable", "data-test", "onClick"]),
                                    _createVNode(_component_q_tooltip, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.canEdit(command) ? 'Edit range' : _ctx.editReason(command)), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.canCancel(command))
                                ? (_openBlock(), _createBlock(_component_q_btn, {
                                    key: 1,
                                    flat: "",
                                    dense: "",
                                    round: "",
                                    size: "sm",
                                    icon: "cancel",
                                    color: "negative",
                                    loading: _ctx.cancellingId === command.commandId,
                                    "data-test": 'queued-command-cancel-' + command.commandId,
                                    onClick: ($event: any) => (_ctx.onCancelClick(command))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_tooltip, null, {
                                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                          _createTextVNode("Cancel download", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["loading", "data-test", "onClick"]))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["data-test"]))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_EditQueuedRangeDialog, {
      modelValue: _ctx.showEditDialog,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showEditDialog) = $event)),
      command: _ctx.editingCommand,
      "firmware-version": _ctx.editingFirmwareVersion,
      onSaved: _ctx.onEditSaved,
      onStale: _ctx.fetchQueuedCommands
    }, null, 8, ["modelValue", "command", "firmware-version", "onSaved", "onStale"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showCancelConfirm,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showCancelConfirm) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"420px","max-width":"90vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "text-bold" }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode("Cancel download?", -1)
              ]))]),
              _: 1
            }),
            (_ctx.cancellingCommand)
              ? (_openBlock(), _createBlock(_component_q_card_section, {
                  key: 0,
                  class: "q-pt-none"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.confirmText(_ctx.cancellingCommand)), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_q_card_actions, { align: "right" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  "no-caps": "",
                  label: "Keep"
                }, null, 512), [
                  [_directive_close_popup]
                ]),
                _createVNode(_component_q_btn, {
                  class: "btn-brand",
                  "no-caps": "",
                  label: "Cancel download",
                  "data-test": "queued-command-cancel-confirm",
                  onClick: _ctx.confirmCancel
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showMessageDialog,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showMessageDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"420px","max-width":"90vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "text-bold" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.messageTitle), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.messageText), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "right" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  "no-caps": "",
                  label: "OK"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}